import {InteractiveMessage} from '../../../../../../shared/models/cerebrum-core';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
    selector: 'app-options-chat-bubble',
    templateUrl: './options-chat-bubble.component.html',
    styleUrls: ['./options-chat-bubble.component.scss'],
    imports: [MatRadioGroup, ReactiveFormsModule, FormsModule, MatRadioButton]
})
export class OptionsChatBubbleComponent implements OnInit {
    @Input() content;

    @Output() sendOption: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    activeOption = false;
    showOptionsPopup = false;
    selectedOption;
    messageDisplay;
    optionsPopupPosition = {
        width: '322px',
        height: '322px',
        left: '0px',
        top: '0px'
    };

    ngOnInit() {
        const chatWindow = document.querySelector('.preview-chat-window') as HTMLElement;
        if (chatWindow) {
            this.optionsPopupPosition = {
                width: `${chatWindow.offsetWidth}px`,
                height: `${chatWindow.offsetHeight + 3}px`,
                left: `${chatWindow.offsetLeft}px`,
                top: `${chatWindow.offsetTop}px`
            };
        }
    }

    openOptionsPopup() {
        if (!this.activeOption) {
            this.showOptionsPopup = true;
        }
    }

    closeOptionsPopup() {
        this.showOptionsPopup = false;
        const chatWindow = document.querySelector('.preview-chat-window') as HTMLElement;
        chatWindow.style.overflowY = 'auto';
    }

    optionSelected(item) {
        this.messageDisplay = item.title;
    }

    sendMessage() {
        const message = (this.content.subtitle === null && this.content.footer !== null) ? this.content.footer
            : (this.content.subtitle !== null && this.content.footer === null) ? this.content.subtitle
                : (this.content.subtitle !== null && this.content.footer !== null) ? this.content.subtitle + ' ' + this.content.footer
                    : '';

        const interactiveMessage: InteractiveMessage = {
            title: 'CLIENT NAME',
            replyMessage: message,
            postbackData: this.selectedOption,
            messageDisplay: this.messageDisplay,
            type: 'list',
            relatedClientMessageId: this.content.clientMessageId
        };

        this.closeOptionsPopup();
        this.sendOption.emit(interactiveMessage);
        this.activeOption = true;
    }
}
